import React                                            from 'react';
import {Icon}                                           from '@sirius/ui-lib/src/blocks/Controls';
import {HBox}                                           from '@sirius/ui-lib/src/blocks/Layout';
import {SubjectIcon}                                    from '@sirius/ui-lib/src/blocks/Controls/SubjectIcon/SubjectIcon';
import subjectIcons                                     from '@sirius/ui-lib/src/blocks/Controls/SubjectIcon/iconComponents/name-list.json';
import {block}                                          from '../block';
import {UiSchemaEntry, DataCellType, ColumnCellType}    from '../@types';

const DataCell:React.FC<DataCellType> = ({row, column}) =>
    <HBox className = {block.el('datacell-icon-text')}>
        {
            row[column.name].icon in subjectIcons
                ? <SubjectIcon subject   = {row[column.name].icon}
                               className = {block.el('datacell-name-icon')}
                               mode      = {'colored'}
                               size      = {'s'}
                />
                : <Icon size      = {'s'}
                        icon      = {row[column.name].icon}
                        className = {block.el('datacell-name-icon')}
                />
        }
        <span className={block.el('datacell-name') + block.el('datacell-icon-text-label')}>
            {row[column.name].data}
        </span>
    </HBox>
;

const ColumnCell:React.FC<ColumnCellType> = ({column}) =>
    <span className={block.el('columncell-name')}>
        {column.title || column.name}
    </span>
;

const IconDataCell: UiSchemaEntry = {
    DataCell, ColumnCell
}

export {IconDataCell}
